import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { BlockComponent } from "@components/container-block/block.component";
import { PageComponent } from "@components/page/page.component";
import { SpanComponent } from "@components/span/span.component";
import { Subject, interval } from "rxjs";
import { startWith, takeUntil } from "rxjs/operators";
import { environment } from "~environments/environment";
import { OvervakningTexts } from "./overvakning.texts";
import { SchemalaggningListComponent } from "./schemalaggning-list/schemalaggning-list.component";
import { SchemalaggningService } from "./schemalaggning.service";

@Component({
    selector: "rask-overvakning",
    templateUrl: "./overvakning.component.html",
    styleUrls: ["./overvakning.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        BlockComponent,
        SpanComponent,
        CheckboxComponent,
        FormsModule,
        SchemalaggningListComponent
    ]
})
export class OvervakningComponent implements OnInit, OnDestroy {
    autoRefresh: boolean;
    texts = OvervakningTexts.texts;
    url = `${environment.apiV2}/maintenance/ai/monitoring`;

    private readonly service = inject(SchemalaggningService);
    private readonly unsubscribe$: Subject<void>;

    constructor() {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }

    ngOnInit(): void {
        this.service.refreshSchemalaggningar();
    }

    onAutoRefreshChange($event): void {
        if ($event) {
            interval(60000)
                .pipe(startWith(0))
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(x => {
                    this.service.refreshSchemalaggningar();
                });
        } else {
            this.unsubscribe();
        }
    }

    openApplicationInsights(): string {
        return this.url;
    }

    private unsubscribe(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
